import Cookies from 'js-cookie';

export default class CookieForm {
  constructor(app) {
    this.app = app;

    this.cookieName = 'medischeartikelen';
    this.cookies = [
      {
        name: 'strictly_necessary',
        selector: '.js-cookie-strictly-necessary',
        value: true,
      },
      {
        name: 'functional',
        selector: '.js-cookie-functional',
        value: true,
      },
      {
        name: 'analytics',
        selector: '.js-cookie-analytics',
        value: false,
      },
      {
        name: 'third_party',
        selector: '.js-cookie-third-party',
        value: false,
      },
    ];

    this.cookieFormSelector = '.js-cookie-form';

    this.init = this.init.bind(this);
    this.events = this.events.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setCookies = this.setCookies.bind(this);
    this.setCookieOptions = this.setCookieOptions.bind(this);

    this.init();
  }

  init() {
    this.cookieForm = document.querySelector(this.cookieFormSelector);
    this.setCookieOptions();

    this.events();
  }

  events() {
    this.cookieForm.addEventListener('submit', this.onSubmit);
  }

  destroy() {
    this.cookieForm.removeEventListener('submit', this.onSubmit);
    if (this.cookieForm) this.cookieForm = null;
  }

  onSubmit(e) {
    e.preventDefault();
    this.setCookies();
    window.location.reload();
  }

  setCookies() {
    Cookies.set(`${this.cookieName}`, true, {
      expires: 365,
      secure: false,
    });

    this.cookies.forEach((cookie) => {
      const option = document.querySelector(cookie.selector);
      if (!option) return;

      const input = option.querySelector('input');
      if (!input) return;

      Cookies.set(`${this.cookieName}-${cookie.name}`, !!input.checked, {
        expires: 365,
        secure: false,
      });
    });
  }

  setCookieOptions() {
    this.cookies.forEach((cookie) => {
      const option = document.querySelector(cookie.selector);
      if (!option) return;

      const input = option.querySelector('input');
      if (!input) return;

      const currentCookieValue = Cookies.get(`${this.cookieName}-${cookie.name}`);
      if (typeof currentCookieValue === 'undefined') {
        input.checked = cookie.value;
      } else if (currentCookieValue === 'true') {
        input.checked = true;
      } else if (currentCookieValue === 'false') {
        input.checked = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/cookieForm.js